<template>
    <el-card>
        <el-tabs v-model="activeName">
            <el-tab-pane label="会员权益" name="first">
                <vip-card-setting></vip-card-setting>
            </el-tab-pane>
            <el-tab-pane label="升级经纪人" name="second">
                <gift-bag-setting></gift-bag-setting>
            </el-tab-pane>
            <el-tab-pane label="充值记录" name="third">
                <opening-card-record></opening-card-record>
            </el-tab-pane>


        </el-tabs>

    </el-card>
</template>
<script>
import OpeningCardRecord from '@/pages/vipCard/cardManager/children/OpeningCardRecord'
import GiftBagSetting from '@/pages/vipCard/cardManager/children/GiftBagSetting'
import VipCardSetting from '@/pages/vipCard/cardManager/children/VipCardSetting'
export default {
  components: { VipCardSetting, GiftBagSetting, OpeningCardRecord },
  data () {
    return {
      activeName: 'first'
    }
  }
}
</script>
